var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 0.484253H2.34375C1.05151 0.484253 0 1.33301 0 2.37607V11.5072C0 12.5503 1.05151 13.399 2.34375 13.399H7.0625V8.83347H5.1875V6.56329H7.0625V5.02461C7.0625 3.77276 8.3241 2.75443 9.875 2.75443H12.7188V5.02461H9.875V6.56329H12.7188L12.25 8.83347H9.875V13.399H13.6562C14.9485 13.399 16 12.5503 16 11.5072V2.37607C16 1.33301 14.9485 0.484253 13.6562 0.484253Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f51d32b83ddb03d5dd2ffa102bd1c6d0.svg";
export { ForwardRef as ReactComponent };